export const baseUrl = '/supplier-locations'
